// @generated by protoc-gen-es v2.2.3 with parameter "target=ts,import_extension=none"
// @generated from file v1/event/event_types.proto (package api.v1.event, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv1";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Money } from "../../google/type/money_pb";
import { file_google_type_money } from "../../google/type/money_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file v1/event/event_types.proto.
 */
export const file_v1_event_event_types: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_google_type_money]);

/**
 * Image represents an image
 *
 * @generated from message api.v1.event.Image
 */
export type Image = Message<"api.v1.event.Image"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string url = 2;
   */
  url: string;

  /**
   * @generated from field: string usage = 3;
   */
  usage: string;

  /**
   * @generated from field: optional string alt_text = 4;
   */
  altText?: string;

  /**
   * @generated from field: optional int32 position = 5;
   */
  position?: number;

  /**
   * @generated from field: optional string storage_path = 6;
   */
  storagePath?: string;

  /**
   * @generated from field: optional int32 width = 7;
   */
  width?: number;

  /**
   * @generated from field: optional int32 height = 8;
   */
  height?: number;

  /**
   * @generated from field: optional string mime_type = 9;
   */
  mimeType?: string;

  /**
   * @generated from field: optional int64 size_bytes = 10;
   */
  sizeBytes?: bigint;

  /**
   * @generated from field: string content_hash = 11;
   */
  contentHash: string;
};

/**
 * Describes the message api.v1.event.Image.
 * Use `create(ImageSchema)` to create a new message.
 */
export const ImageSchema: GenMessage<Image> = /*@__PURE__*/
  messageDesc(file_v1_event_event_types, 0);

/**
 * Tag represents an event tag
 *
 * @generated from message api.v1.event.Tag
 */
export type Tag = Message<"api.v1.event.Tag"> & {
  /**
   * @generated from field: string name = 2;
   */
  name: string;
};

/**
 * Describes the message api.v1.event.Tag.
 * Use `create(TagSchema)` to create a new message.
 */
export const TagSchema: GenMessage<Tag> = /*@__PURE__*/
  messageDesc(file_v1_event_event_types, 1);

/**
 * FAQ represents a frequently asked question
 *
 * @generated from message api.v1.event.FAQ
 */
export type FAQ = Message<"api.v1.event.FAQ"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string question = 2;
   */
  question: string;

  /**
   * @generated from field: string answer = 3;
   */
  answer: string;

  /**
   * @generated from field: string category = 4;
   */
  category: string;

  /**
   * @generated from field: int32 order = 5;
   */
  order: number;
};

/**
 * Describes the message api.v1.event.FAQ.
 * Use `create(FAQSchema)` to create a new message.
 */
export const FAQSchema: GenMessage<FAQ> = /*@__PURE__*/
  messageDesc(file_v1_event_event_types, 2);

/**
 * EventCollaborator represents a collaborator on an event
 *
 * @generated from message api.v1.event.EventCollaborator
 */
export type EventCollaborator = Message<"api.v1.event.EventCollaborator"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string event_id = 2;
   */
  eventId: string;

  /**
   * @generated from field: api.v1.event.EventCollaboratorEntityType entity_type = 3;
   */
  entityType: EventCollaboratorEntityType;

  /**
   * user_id or org_id
   *
   * @generated from field: string entity_id = 4;
   */
  entityId: string;

  /**
   * @generated from field: string name = 5;
   */
  name: string;

  /**
   * username or org slug
   *
   * @generated from field: string username = 6;
   */
  username: string;

  /**
   * @generated from field: optional string avatar_url = 7;
   */
  avatarUrl?: string;

  /**
   * @generated from field: api.v1.event.EventCollaborationType collaboration_type = 8;
   */
  collaborationType: EventCollaborationType;

  /**
   * Status fields
   *
   * @generated from field: api.v1.event.EventCollaboratorRequesterStatus requester_status = 9;
   */
  requesterStatus: EventCollaboratorRequesterStatus;

  /**
   * @generated from field: api.v1.event.EventCollaboratorRequesteeStatus requestee_status = 10;
   */
  requesteeStatus: EventCollaboratorRequesteeStatus;

  /**
   * If denied, provide a reason
   *
   * @generated from field: optional api.v1.event.EventCollaboratorDenialReason denial_reason = 11;
   */
  denialReason?: EventCollaboratorDenialReason;

  /**
   * @generated from field: optional string denial_reason_other = 12;
   */
  denialReasonOther?: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 13;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 14;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message api.v1.event.EventCollaborator.
 * Use `create(EventCollaboratorSchema)` to create a new message.
 */
export const EventCollaboratorSchema: GenMessage<EventCollaborator> = /*@__PURE__*/
  messageDesc(file_v1_event_event_types, 3);

/**
 * CollaboratorSearchResult represents a search result for collaborators
 *
 * @generated from message api.v1.event.CollaboratorSearchResult
 */
export type CollaboratorSearchResult = Message<"api.v1.event.CollaboratorSearchResult"> & {
  /**
   * @generated from field: api.v1.event.EventCollaboratorEntityType entity_type = 2;
   */
  entityType: EventCollaboratorEntityType;

  /**
   * @generated from field: string id = 3;
   */
  id: string;

  /**
   * @generated from field: string name = 4;
   */
  name: string;

  /**
   * username or slug
   *
   * @generated from field: string username = 5;
   */
  username: string;

  /**
   * @generated from field: optional string avatar_url = 6;
   */
  avatarUrl?: string;

  /**
   * @generated from field: optional string bio = 7;
   */
  bio?: string;
};

/**
 * Describes the message api.v1.event.CollaboratorSearchResult.
 * Use `create(CollaboratorSearchResultSchema)` to create a new message.
 */
export const CollaboratorSearchResultSchema: GenMessage<CollaboratorSearchResult> = /*@__PURE__*/
  messageDesc(file_v1_event_event_types, 4);

/**
 * EventAttendee represents an attendee of an event
 *
 * @generated from message api.v1.event.EventAttendee
 */
export type EventAttendee = Message<"api.v1.event.EventAttendee"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string event_id = 2;
   */
  eventId: string;

  /**
   * @generated from field: string user_id = 3;
   */
  userId: string;

  /**
   * @generated from field: string name = 4;
   */
  name: string;

  /**
   * @generated from field: string email = 5;
   */
  email: string;

  /**
   * @generated from field: optional string qr_code_token = 6;
   */
  qrCodeToken?: string;

  /**
   * @generated from field: optional string qr_code_url = 7;
   */
  qrCodeUrl?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp checked_in_at = 8;
   */
  checkedInAt?: Timestamp;

  /**
   * @generated from field: optional api.v1.event.CheckInMethod check_in_method = 9;
   */
  checkInMethod?: CheckInMethod;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */
  createdAt?: Timestamp;

  /**
   * User's username for profile navigation
   *
   * @generated from field: string username = 11;
   */
  username: string;

  /**
   * User's avatar image URL
   *
   * @generated from field: optional string avatar_url = 12;
   */
  avatarUrl?: string;
};

/**
 * Describes the message api.v1.event.EventAttendee.
 * Use `create(EventAttendeeSchema)` to create a new message.
 */
export const EventAttendeeSchema: GenMessage<EventAttendee> = /*@__PURE__*/
  messageDesc(file_v1_event_event_types, 5);

/**
 * RecentCheckIn represents a recent check-in for real-time display
 *
 * @generated from message api.v1.event.RecentCheckIn
 */
export type RecentCheckIn = Message<"api.v1.event.RecentCheckIn"> & {
  /**
   * @generated from field: string attendee_name = 1;
   */
  attendeeName: string;

  /**
   * @generated from field: string attendee_email = 2;
   */
  attendeeEmail: string;

  /**
   * @generated from field: google.protobuf.Timestamp check_in_time = 3;
   */
  checkInTime?: Timestamp;

  /**
   * @generated from field: string check_in_method = 4;
   */
  checkInMethod: string;
};

/**
 * Describes the message api.v1.event.RecentCheckIn.
 * Use `create(RecentCheckInSchema)` to create a new message.
 */
export const RecentCheckInSchema: GenMessage<RecentCheckIn> = /*@__PURE__*/
  messageDesc(file_v1_event_event_types, 6);

/**
 * AttendanceTimePoint represents a point in time for attendance timeline
 *
 * @generated from message api.v1.event.AttendanceTimePoint
 */
export type AttendanceTimePoint = Message<"api.v1.event.AttendanceTimePoint"> & {
  /**
   * @generated from field: google.protobuf.Timestamp time = 1;
   */
  time?: Timestamp;

  /**
   * @generated from field: int32 cumulative_count = 2;
   */
  cumulativeCount: number;
};

/**
 * Describes the message api.v1.event.AttendanceTimePoint.
 * Use `create(AttendanceTimePointSchema)` to create a new message.
 */
export const AttendanceTimePointSchema: GenMessage<AttendanceTimePoint> = /*@__PURE__*/
  messageDesc(file_v1_event_event_types, 7);

/**
 * Event represents an event
 *
 * @generated from message api.v1.event.Event
 */
export type Event = Message<"api.v1.event.Event"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string org_id = 2;
   */
  orgId: string;

  /**
   * @generated from field: string org_slug = 3;
   */
  orgSlug: string;

  /**
   * @generated from field: string org_name = 4;
   */
  orgName: string;

  /**
   * @generated from field: string title = 5;
   */
  title: string;

  /**
   * @generated from field: string description = 6;
   */
  description: string;

  /**
   * @generated from field: api.v1.event.EventType event_type = 7;
   */
  eventType: EventType;

  /**
   * @generated from field: optional string ticket_url = 8;
   */
  ticketUrl?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp registration_deadline = 9;
   */
  registrationDeadline?: Timestamp;

  /**
   * @generated from field: optional google.type.Money price = 10;
   */
  price?: Money;

  /**
   * @generated from field: optional int32 capacity = 11;
   */
  capacity?: number;

  /**
   * @generated from field: int32 attendees_count = 12;
   */
  attendeesCount: number;

  /**
   * @generated from field: repeated api.v1.event.Image images = 13;
   */
  images: Image[];

  /**
   * @generated from field: api.v1.event.EventStatus status = 14;
   */
  status: EventStatus;

  /**
   * @generated from field: repeated api.v1.event.Tag tags = 15;
   */
  tags: Tag[];

  /**
   * @generated from field: google.protobuf.Timestamp start_date = 16;
   */
  startDate?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp end_date = 17;
   */
  endDate?: Timestamp;

  /**
   * @generated from field: string timezone = 18;
   */
  timezone: string;

  /**
   * @generated from field: optional string venue_name = 19;
   */
  venueName?: string;

  /**
   * @generated from field: optional string address = 20;
   */
  address?: string;

  /**
   * @generated from field: optional string city = 21;
   */
  city?: string;

  /**
   * @generated from field: optional string state = 22;
   */
  state?: string;

  /**
   * @generated from field: optional string postal_code = 23;
   */
  postalCode?: string;

  /**
   * @generated from field: optional string country = 24;
   */
  country?: string;

  /**
   * @generated from field: optional double latitude = 25;
   */
  latitude?: number;

  /**
   * @generated from field: optional double longitude = 26;
   */
  longitude?: number;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 27;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 29;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp deleted_at = 30;
   */
  deletedAt?: Timestamp;

  /**
   * Event FAQs
   *
   * @generated from field: repeated api.v1.event.FAQ faq_content = 31;
   */
  faqContent: FAQ[];

  /**
   * Event collaborators
   *
   * @generated from field: repeated api.v1.event.EventCollaborator collaborators = 32;
   */
  collaborators: EventCollaborator[];

  /**
   * External ticketing fields (verified organizations only)
   *
   * @generated from field: optional string external_ticket_url = 33;
   */
  externalTicketUrl?: string;

  /**
   * false for external ticketing events
   *
   * @generated from field: bool allows_rsvp = 34;
   */
  allowsRsvp: boolean;

  /**
   * @generated from field: optional google.type.Money ticket_price_min = 35;
   */
  ticketPriceMin?: Money;

  /**
   * @generated from field: optional google.type.Money ticket_price_max = 36;
   */
  ticketPriceMax?: Money;

  /**
   * e.g., "Ticketmaster", "Eventbrite"
   *
   * @generated from field: optional string external_ticket_provider = 37;
   */
  externalTicketProvider?: string;

  /**
   * @generated from field: api.v1.event.EventVisibility visibility = 38;
   */
  visibility: EventVisibility;

  /**
   * Tiptap JSONContent for rich text
   *
   * @generated from field: optional string description_rich = 39;
   */
  descriptionRich?: string;
};

/**
 * Describes the message api.v1.event.Event.
 * Use `create(EventSchema)` to create a new message.
 */
export const EventSchema: GenMessage<Event> = /*@__PURE__*/
  messageDesc(file_v1_event_event_types, 8);

/**
 * ===== Top-level Enums =====
 *
 * @generated from enum api.v1.event.EventType
 */
export enum EventType {
  /**
   * @generated from enum value: EVENT_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: EVENT_TYPE_ARTS = 1;
   */
  ARTS = 1,

  /**
   * @generated from enum value: EVENT_TYPE_CLASSES_WORKSHOPS = 2;
   */
  CLASSES_WORKSHOPS = 2,

  /**
   * @generated from enum value: EVENT_TYPE_CONFERENCE = 3;
   */
  CONFERENCE = 3,

  /**
   * @generated from enum value: EVENT_TYPE_ENTERTAINMENT = 4;
   */
  ENTERTAINMENT = 4,

  /**
   * @generated from enum value: EVENT_TYPE_FESTIVAL = 5;
   */
  FESTIVAL = 5,

  /**
   * @generated from enum value: EVENT_TYPE_FUNDRAISER = 6;
   */
  FUNDRAISER = 6,

  /**
   * @generated from enum value: EVENT_TYPE_MARKET = 7;
   */
  MARKET = 7,

  /**
   * @generated from enum value: EVENT_TYPE_NETWORKING = 8;
   */
  NETWORKING = 8,

  /**
   * @generated from enum value: EVENT_TYPE_OTHER = 9;
   */
  OTHER = 9,

  /**
   * @generated from enum value: EVENT_TYPE_WORKSHOP = 10;
   */
  WORKSHOP = 10,
}

/**
 * Describes the enum api.v1.event.EventType.
 */
export const EventTypeSchema: GenEnum<EventType> = /*@__PURE__*/
  enumDesc(file_v1_event_event_types, 0);

/**
 * @generated from enum api.v1.event.EventStatus
 */
export enum EventStatus {
  /**
   * @generated from enum value: EVENT_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: EVENT_STATUS_DRAFT = 1;
   */
  DRAFT = 1,

  /**
   * @generated from enum value: EVENT_STATUS_PUBLISHED = 2;
   */
  PUBLISHED = 2,

  /**
   * @generated from enum value: EVENT_STATUS_CANCELLED = 3;
   */
  CANCELLED = 3,

  /**
   * @generated from enum value: EVENT_STATUS_POSTPONED = 4;
   */
  POSTPONED = 4,

  /**
   * @generated from enum value: EVENT_STATUS_COMPLETED = 5;
   */
  COMPLETED = 5,
}

/**
 * Describes the enum api.v1.event.EventStatus.
 */
export const EventStatusSchema: GenEnum<EventStatus> = /*@__PURE__*/
  enumDesc(file_v1_event_event_types, 1);

/**
 * @generated from enum api.v1.event.EventVisibility
 */
export enum EventVisibility {
  /**
   * @generated from enum value: EVENT_VISIBILITY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: EVENT_VISIBILITY_PUBLIC = 1;
   */
  PUBLIC = 1,

  /**
   * @generated from enum value: EVENT_VISIBILITY_PRIVATE = 2;
   */
  PRIVATE = 2,
}

/**
 * Describes the enum api.v1.event.EventVisibility.
 */
export const EventVisibilitySchema: GenEnum<EventVisibility> = /*@__PURE__*/
  enumDesc(file_v1_event_event_types, 2);

/**
 * @generated from enum api.v1.event.RegistrationStatus
 */
export enum RegistrationStatus {
  /**
   * @generated from enum value: REGISTRATION_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: REGISTRATION_STATUS_NOT_REGISTERED = 1;
   */
  NOT_REGISTERED = 1,

  /**
   * @generated from enum value: REGISTRATION_STATUS_REGISTERED = 2;
   */
  REGISTERED = 2,

  /**
   * @generated from enum value: REGISTRATION_STATUS_WAITLISTED = 3;
   */
  WAITLISTED = 3,

  /**
   * @generated from enum value: REGISTRATION_STATUS_CANCELLED = 4;
   */
  CANCELLED = 4,
}

/**
 * Describes the enum api.v1.event.RegistrationStatus.
 */
export const RegistrationStatusSchema: GenEnum<RegistrationStatus> = /*@__PURE__*/
  enumDesc(file_v1_event_event_types, 3);

/**
 * @generated from enum api.v1.event.CheckInMethod
 */
export enum CheckInMethod {
  /**
   * @generated from enum value: CHECK_IN_METHOD_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CHECK_IN_METHOD_QR_CODE = 1;
   */
  QR_CODE = 1,

  /**
   * @generated from enum value: CHECK_IN_METHOD_MANUAL = 2;
   */
  MANUAL = 2,
}

/**
 * Describes the enum api.v1.event.CheckInMethod.
 */
export const CheckInMethodSchema: GenEnum<CheckInMethod> = /*@__PURE__*/
  enumDesc(file_v1_event_event_types, 4);

/**
 * @generated from enum api.v1.event.EventCollaboratorEntityType
 */
export enum EventCollaboratorEntityType {
  /**
   * @generated from enum value: COLLABORATOR_ENTITY_TYPE_UNSPECIFIED = 0;
   */
  COLLABORATOR_ENTITY_TYPE_UNSPECIFIED = 0,

  /**
   * @generated from enum value: COLLABORATOR_ENTITY_TYPE_USER = 1;
   */
  COLLABORATOR_ENTITY_TYPE_USER = 1,

  /**
   * @generated from enum value: COLLABORATOR_ENTITY_TYPE_ORG = 2;
   */
  COLLABORATOR_ENTITY_TYPE_ORG = 2,
}

/**
 * Describes the enum api.v1.event.EventCollaboratorEntityType.
 */
export const EventCollaboratorEntityTypeSchema: GenEnum<EventCollaboratorEntityType> = /*@__PURE__*/
  enumDesc(file_v1_event_event_types, 5);

/**
 * @generated from enum api.v1.event.EventCollaborationType
 */
export enum EventCollaborationType {
  /**
   * @generated from enum value: COLLABORATION_TYPE_UNSPECIFIED = 0;
   */
  COLLABORATION_TYPE_UNSPECIFIED = 0,

  /**
   * @generated from enum value: COLLABORATION_TYPE_VENDOR = 1;
   */
  COLLABORATION_TYPE_VENDOR = 1,

  /**
   * @generated from enum value: COLLABORATION_TYPE_PERFORMER = 2;
   */
  COLLABORATION_TYPE_PERFORMER = 2,

  /**
   * @generated from enum value: COLLABORATION_TYPE_PARTNER = 3;
   */
  COLLABORATION_TYPE_PARTNER = 3,

  /**
   * @generated from enum value: COLLABORATION_TYPE_SPONSOR = 4;
   */
  COLLABORATION_TYPE_SPONSOR = 4,

  /**
   * @generated from enum value: COLLABORATION_TYPE_OTHER = 5;
   */
  COLLABORATION_TYPE_OTHER = 5,
}

/**
 * Describes the enum api.v1.event.EventCollaborationType.
 */
export const EventCollaborationTypeSchema: GenEnum<EventCollaborationType> = /*@__PURE__*/
  enumDesc(file_v1_event_event_types, 6);

/**
 * @generated from enum api.v1.event.EventCollaboratorRequesterStatus
 */
export enum EventCollaboratorRequesterStatus {
  /**
   * @generated from enum value: REQUESTER_STATUS_UNSPECIFIED = 0;
   */
  REQUESTER_STATUS_UNSPECIFIED = 0,

  /**
   * @generated from enum value: REQUESTER_STATUS_ACTIVE = 1;
   */
  REQUESTER_STATUS_ACTIVE = 1,

  /**
   * @generated from enum value: REQUESTER_STATUS_HIDDEN = 2;
   */
  REQUESTER_STATUS_HIDDEN = 2,

  /**
   * @generated from enum value: REQUESTER_STATUS_REMOVED = 3;
   */
  REQUESTER_STATUS_REMOVED = 3,
}

/**
 * Describes the enum api.v1.event.EventCollaboratorRequesterStatus.
 */
export const EventCollaboratorRequesterStatusSchema: GenEnum<EventCollaboratorRequesterStatus> = /*@__PURE__*/
  enumDesc(file_v1_event_event_types, 7);

/**
 * @generated from enum api.v1.event.EventCollaboratorRequesteeStatus
 */
export enum EventCollaboratorRequesteeStatus {
  /**
   * @generated from enum value: REQUESTEE_STATUS_UNSPECIFIED = 0;
   */
  REQUESTEE_STATUS_UNSPECIFIED = 0,

  /**
   * @generated from enum value: REQUESTEE_STATUS_PENDING = 1;
   */
  REQUESTEE_STATUS_PENDING = 1,

  /**
   * @generated from enum value: REQUESTEE_STATUS_APPROVED = 2;
   */
  REQUESTEE_STATUS_APPROVED = 2,

  /**
   * @generated from enum value: REQUESTEE_STATUS_DENIED = 3;
   */
  REQUESTEE_STATUS_DENIED = 3,

  /**
   * @generated from enum value: REQUESTEE_STATUS_HIDDEN = 4;
   */
  REQUESTEE_STATUS_HIDDEN = 4,

  /**
   * @generated from enum value: REQUESTEE_STATUS_REMOVED = 5;
   */
  REQUESTEE_STATUS_REMOVED = 5,
}

/**
 * Describes the enum api.v1.event.EventCollaboratorRequesteeStatus.
 */
export const EventCollaboratorRequesteeStatusSchema: GenEnum<EventCollaboratorRequesteeStatus> = /*@__PURE__*/
  enumDesc(file_v1_event_event_types, 8);

/**
 * @generated from enum api.v1.event.EventCollaboratorDenialReason
 */
export enum EventCollaboratorDenialReason {
  /**
   * @generated from enum value: DENIAL_REASON_UNSPECIFIED = 0;
   */
  DENIAL_REASON_UNSPECIFIED = 0,

  /**
   * @generated from enum value: DENIAL_REASON_SPAM = 1;
   */
  DENIAL_REASON_SPAM = 1,

  /**
   * @generated from enum value: DENIAL_REASON_INAPPROPRIATE = 2;
   */
  DENIAL_REASON_INAPPROPRIATE = 2,

  /**
   * @generated from enum value: DENIAL_REASON_DONT_KNOW = 3;
   */
  DENIAL_REASON_DONT_KNOW = 3,

  /**
   * @generated from enum value: DENIAL_REASON_MISTAKE = 4;
   */
  DENIAL_REASON_MISTAKE = 4,

  /**
   * @generated from enum value: DENIAL_REASON_NOT_INTERESTED = 5;
   */
  DENIAL_REASON_NOT_INTERESTED = 5,

  /**
   * @generated from enum value: DENIAL_REASON_NO_LONGER_PARTICIPATING = 6;
   */
  DENIAL_REASON_NO_LONGER_PARTICIPATING = 6,

  /**
   * @generated from enum value: DENIAL_REASON_OTHER = 99;
   */
  DENIAL_REASON_OTHER = 99,
}

/**
 * Describes the enum api.v1.event.EventCollaboratorDenialReason.
 */
export const EventCollaboratorDenialReasonSchema: GenEnum<EventCollaboratorDenialReason> = /*@__PURE__*/
  enumDesc(file_v1_event_event_types, 9);

